import { Application } from "@hotwired/stimulus"
import toastr from "toastr"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
document.addEventListener("click", function(e) {
    document.querySelectorAll(".dropdown-menu.show")
  document.querySelectorAll(".dropdown-menu.show").forEach(menu => {
    if (!menu.parentElement.contains(e.target)) {
      menu.classList.remove("show");
      menu.previousElementSibling.setAttribute("aria-expanded", "false");
    }
  });
});